import React from "react";

import NutStat from "../../components/Nutstat";

export default (props) => <NutStat {...props} />;
